<template>
  <div class="container">
    <div class='container-fluid'>
      <div class='row justify-content-center'>
        <div class="col-md-10">
          <div class="container text-center">
            <span>Slack Connection Status:</span>
            <h1>{{oauthval}}</h1>
          
          </div>
        </div>
      </div>
    </div>
  </div>

</template>    

<script>
// @ is an alias to /src

var Parse = require('parse/node');
Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_JS_KEY);
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL;

export default {
  name: 'SlackAuth',
  components: {
  },
  data: function () {
    return {
      code: "",
      oauthval: "Pending"
    }
  },
  created() {
    
  },
  mounted: function () {
    
    console.log('hello world');
    let urlParams = new URLSearchParams(window.location.search);
    let slackCode = urlParams.get('code');
    let slackState = urlParams.get('state');
    let stateString = atob(slackState);
    let stateObj = JSON.parse(stateString);

    // First get company data
    let companyId = stateObj.appId;
    const Company = Parse.Object.extend("Company");
    const companyQuery = new Parse.Query(Company);
    companyQuery.equalTo("objectId", companyId);
    companyQuery.first().then((companyResult) => {
      let clientId = process.env.VUE_APP_SLACK_DEFAULT_CLIENT_ID;
      let clientSecret = process.env.VUE_APP_SLACK_DEFAULT_CLIENT_SECRET;
      if (companyResult.get("UsingOwnSlackApp")) {
        clientId = companyResult.get("SlackClientId");
        clientSecret = companyResult.get("SlackClientSecret");
      }

      var paramdata = new URLSearchParams();
      paramdata.append('client_id', clientId);
      paramdata.append('client_secret', clientSecret);
      paramdata.append('code', slackCode);
      paramdata.append('redirect_uri', 'https://app.ravenhub.io/slack-auth');
      

      fetch('https://slack.com/api/oauth.access', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: paramdata
      }).then(response => 
        response.json().then(data => ({
          data: data,
          status: response.status
        })).then(res => {
        

        // Fetch Event Type Instance
        const EventTypeInstance = Parse.Object.extend("EventTypeInstance");
        const query = new Parse.Query(EventTypeInstance);
        query.equalTo("objectId", stateObj.eventTypeInstanceId);
        query.first().then((resultObject) => {
          resultObject.set('webhookUrl', res.data.incoming_webhook.url);
          resultObject.set('channelName', res.data.incoming_webhook.channel);
          resultObject.set('accessToken', res.data.access_token);

          resultObject.save().then((response) => {
            console.log('Updated EventTypeInstance', response);
            this.oauthval = 'Success!'
            window.open(stateObj.redirUrl,  '_self');
          }, (error) => {
            console.error('Error while updating EventTypeInstance', error);
            this.oauthval = 'Error. Something went wrong.'
          });

        });
      }));
    });
    
  },
  
  methods: {
    
   
  }
}

</script>